import { jsx as _jsx } from "react/jsx-runtime";
import styles from './InventoryNumber.module.css';
/** Numéro d'inventaire de la galerie (numérotation propre à chaque galerie, 3.2), en Plex Mono. */
export function InventoryNumber({ value, className, ...rest }) {
    const classes = [styles.number, className].filter(Boolean).join(' ');
    return (_jsx("span", { className: classes, ...rest, children: value }));
}
//# sourceMappingURL=InventoryNumber.js.map